export default __webpack_public_path__ + "static/media/FoodChainForest_12.07214122.png";